import { gql } from "@apollo/client";

export const LIST_INVENTORIES = gql`
    query ListInventories(
        $clientCode: ClientCodeEnum!
    ) {
        listInventories(
            clientCode: $clientCode
        ) {
            inventories {
                id
                vin
                vehicleId
                modelCode
                modelTrim
                color
                exteriorColor
                interiorColor
                shipName
                locationSeq
                locationStatus
                orderNo
                offlineDate
                fhiDeparture
                vesselEta
                dealerId
                vehicleType
                globalExteriorColor
                globalInteriorColor
                metadata {
                    createdAt
                    createdBy
                }
                vehicleInfo {
                    year
                    make
                    trim
                }
                additionalData {
                    name
                    value
                }
            }
            metadata {
                lastKey
            }
        }
    }
`;

export const GET_INVENTORY = gql`
    query GetInventory(
        $clientCode: ClientCodeEnum!
        $id: String!
    ) {
        getInventory(
            clientCode: $clientCode
            id: $id
        ) {
            id
            vin
            vehicleId
            modelCode
            modelTrim
            color
            exteriorColor
            interiorColor
            shipName
            locationSeq
            locationStatus
            orderNo
            offlineDate
            fhiDeparture
            vesselEta
            dealerId
            vehicleType
            globalExteriorColor
            globalInteriorColor
            vehicleInfo {
                retireDate
                warrantyDate
                accessories
                tag
                description
                plate
                make
                keys
                bodyStyle
                year
                transmission
                engine
                driveTrain
                roof
                tires
                trim
                oemId
                shId
                vmhId
                star
                availableDate
                km
                fuel
                isNewModel
                isPrototype
                isRedesign
            }
            metadata {
                createdAt
                createdBy
                isOverriddenBySystem
                isLatestVersion
                parentVersionId
            }
            additionalData {
                name
                value
            }
        }
    }
`;
